
    var riot = require('riot')
    
riot.tag2('interpreter', '<div class="profile-wrapper"> <h3>Update your profile</h3> <form class="form-horizontal"> <div class="row"> <div class="col-xs-12 profile-box"> <div class="row"> <div class="col-xs-12 col-sm-4 col-md-2"> <label class="control-label text-left">Profile image</label> <uploadimage on-click="{uploadimage}" width1="4" width2="8"><img riot-tag="img_loader" riot-src="/images/avatars/user{parent.user.id}.jpg?u={parent.cachebuster}" default="/images/avatars/default.svg" class="img-thumbnail"></uploadimage> </div> <div class="col-xs-12 col-sm-8 col-md-10 biobox"> <formtextarea name="bio" label="Bio" onupdate="{handleUpdate}" value="{user.bio}" width1="12" width2="12" rows="8"></formtextarea> </div> </div> </div> <div class="col-xs-12 profile-box"> <div class="row"> <div class="col-xs-12 col-md-6"> <forminput name="first_name" label="First Name" onupdate="{handleUpdate}" value="{user.first_name}" width1="4" width2="8"></forminput> </div> <div class="col-xs-12 col-md-6"> <forminput name="surname" label="Surname" onupdate="{handleUpdate}" value="{user.surname}" width1="4" width2="8"></forminput> </div> <div class="col-xs-12 col-md-6"> <forminput name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="4" width2="8"></forminput> </div> <div class="col-xs-12 col-md-6"> <forminput name="phone1" label="Telephone" onupdate="{handleUpdate}" value="{user.phone1}" width1="4" width2="8"></forminput> </div> <div class="col-xs-12 col-md-6"> <forminput name="phone2" label="Mobile" onupdate="{handleUpdate}" value="{user.phone2}" width1="4" width2="8"></forminput> </div> <div class="col-xs-12 col-md-6"> <formselect name="gender" label="Gender" onupdate="{handleUpdate}" value="{user.gender}" width1="4" width2="8" default="Please Choose" options="{[{label:\'Male\',value:\'male\'},{label:\'Female\',value:\'female\'}]}"></formselect> </div> </div> </div> <div class="col-xs-12 profile-box"> <div class="row"> <div class="col-xs-12 col-md-12"> <hr> <h4 class="col-xs-6">Services</h4> <h4 class="col-xs-6">Experience</h4> <div class="col-xs-6"> <div each="{sec in services}"> <formcheckbox value="{parent.selected_services.indexOf(sec.value) &gt; -1}" label="{sec.label}" onchange="{updateServices.bind(null,sec.value)}" width1="1" width2="8"></formcheckbox> </div> </div> <div class="col-xs-6"> <forminput name="years_experience" label="Years Experience" onupdate="{handleUpdate}" value="{user.years_experience}" width1="4" width2="8" type="{\'number\'}"></forminput> <formtextarea name="qualifications" label="Qualifications" onupdate="{handleUpdate}" rows="7" value="{user.qualifications}" width1="4" width2="8"></formtextarea> </div> </div> </div> </div> <div class="col-xs-12 text-right"> <div class="btn btn-toolbar"><a href="/services/booking-an-interpreter/interpreters/?id={user.id}" target="_blank" class="btn btn-default">View Profile</a> <button onclick="{handleSaveProfile}" class="btn btn-primary">Save profile</button> </div> <hr> </div> </div> </form> </div> <toaster class="toaster"></toaster>', '.cbsector label { font-weight: 300; } .biobox .control-label { text-align: left; } uploadimage { display: block; } .client-row { display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; -webkit-box-lines: multiple; -moz-box-lines: multiple; -o-box-lines: multiple; -webkit-flex-wrap: wrap; -ms-flex-wrap: wrap; flex-wrap: wrap; } .client-row .client { margin-bottom: 30px; display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; -webkit-box-orient: vertical; -moz-box-orient: vertical; -o-box-orient: vertical; -webkit-flex-direction: column; -ms-flex-direction: column; flex-direction: column; position: relative; border-radius: 5px; background: #fff; } .client-row .client .imgwrap { -webkit-box-flex: 10; -moz-box-flex: 10; -o-box-flex: 10; box-flex: 10; -webkit-flex: 10; -ms-flex: 10; flex: 10; display: -webkit-box; display: -moz-box; display: -webkit-flex; display: -ms-flexbox; display: box; display: flex; -webkit-box-align: center; -moz-box-align: center; -o-box-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center; -webkit-box-pack: center; -moz-box-pack: center; -o-box-pack: center; -ms-flex-pack: center; -webkit-justify-content: center; justify-content: center; } .client-row .client img { max-width: 90%; } .client-row .client.withlogo { height: 165px; } .client-row .client h5 { padding: 5px 5px; } @media (min-width: 768px) { .pilabel { text-align: right; } }', '', function(opts) {
var xhr;

xhr = require("../libs/xhr.coffee");

this.show_unknown_client_input = false;

this.services = require("../libs/service-list.coffee");

this.on('mount', function() {
  this.selected_services = [];
  if (window.location.search.match(/editmode=/)) {
    return this.root.innerHTML = "<div style='border:2px dashed #a00'>Profile Component</div>";
  } else {
    this.toaster = document.querySelector('toaster');
    return xhr("GET", '/duocms/api/users/me', null, (function(_this) {
      return function(res) {
        var data, ref;
        data = res.body.data;
        if ((data != null ? data.id : void 0) != null) {
          _this.user = data;
          _this.selected_services = ((ref = _this.user.services) != null ? ref.split(",") : void 0) || [];
          return _this.update();
        }
      };
    })(this));
  }
});

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function(e) {
    e.preventDefault();
    _this.user.services = _this.selected_services.join(",");
    return xhr("POST", '/duocms/api/users/me', _this.user, function(res) {
      if (res.body.status !== "success") {
        return _this.toaster.trigger('add', {
          title: 'Failed',
          message: res.body.message || "There was an error saving your profile",
          type: 'error'
        });
      } else {
        return _this.toaster.trigger('add', {
          title: 'Successful',
          message: res.body.message || "Your profile has been saved",
          type: 'success'
        });
      }
    });
  };
})(this);

this.cachebuster = "";

this.updateServices = (function(_this) {
  return function(service) {
    if (_this.selected_services.indexOf(service) > -1) {
      return _this.selected_services.splice(_this.selected_services.indexOf(service), 1);
    } else {
      return _this.selected_services.push(service);
    }
  };
})(this);

this.uploadimage = (function(_this) {
  return function(file) {
    var formData, self;
    formData = new FormData();
    formData.append("file", file);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/users/me/upload_avatar?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function(e) {
      var resp;
      console.log("upload response", e, this.response);
      resp = JSON.parse(this.response);
      self.cachebuster = +(new Date());
      return self.update();
    };
    return xhr.send(formData);
  };
})(this);
});
    
  